import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logoSm from '../assets/global/logo-sm.svg';
import logo from '../assets/global/logo.svg';
import { InstagramIcon, FacebookIcon } from '../assets/global/Icons';
import './Header.scss';

function Header() {

    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        function handleScroll() {
            if (window.scrollY > 5) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        }

        window.addEventListener('scroll', handleScroll);

        // cleanup listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <header className="main-header">
            <Link to="/" className="inline-block">
                <img
                    className={isScrolled ? 'main-header__logo--sm' : 'main-header__logo'}
                    src={isScrolled ? logoSm : logo}
                />
            </Link>
            <a href="https://www.instagram.com/conniescakerie" target="_blank" rel="noopener noreferrer" className="inline=-block">
                <InstagramIcon
                    className="instagram-icon"
                    role="button"
                    aria-label="Follow us on Instagram"
                />
            </a>
            <a href="https://www.facebook.com/conniescakerie" target="_blank" rel="noopener noreferrer" className="inline=-block">
                <FacebookIcon
                    className="facebook-icon"
                    role="button"
                    aria-label="Like our page"
                />
            </a>
        </header>
    );
}

export default Header;